import { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete, TextField } from '@mui/material';
import { NOT_AVAILABLE } from '../shared/AppConstants';

export default function UserDropDownSearch({
  name,
  control,
  defaultValue,
  rules,
  masterUserList,
  isError,
  customOnChangeHandler = () => {},
  runCustomOnChangeHandler = false
}) {
  const [options, setOptions] = useState(null);

  function optionsSort(a, b) {
    // Compare Last names
    let nameA = a.upperLastName;
    let nameB = b.upperLastName;

    if (nameA < nameB) return -1;
    else if (nameA > nameB) return 1;
    else {
      // Last Names are equal, Compare First names
      nameA = a.upperFirstName;
      nameB = b.upperFirstName;
      if (nameA < nameB) return -1;
      else if (nameA > nameB) return 1;
      else return 0;
    }
  }

  const loadMasterOptions = () => {
    let tempList = [...new Set(masterUserList)];
    if (tempList && tempList.length > 1) tempList.sort(optionsSort);

    const data = tempList
      .filter((item) => item !== null && item !== undefined)
      .map((item) => {
        return {
          value: item.id,
          label:
            (item.lastName !== NOT_AVAILABLE ? item.lastName : '') +
            (item.firstName !== NOT_AVAILABLE ? ', ' + item.firstName : '') +
            (item.firstName !== NOT_AVAILABLE && item.middleInitial !== null
              ? ' ' + item.middleInitial
              : '') +
            ' - ' +
            item.id.toUpperCase()
        };
      });
    setOptions(data);
  };

  useEffect(() => {
    loadMasterOptions(); // setting options
  }, []);

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue || null}
      render={({ field }) => {
        return (
          <Autocomplete
            fullWidth
            disabled={false}
            getOptionLabel={(option) => option?.label || ''}
            isOptionEqualToValue={(option, value) =>
              !value || option.value === value.value
            }
            options={options?.length ? options : []}
            onChange={(e, data) => {
              field.onChange(data || null);

              if (runCustomOnChangeHandler) {
                customOnChangeHandler(e, data);
              }
            }}
            onBlur={field.onBlur}
            value={field.value || null}
            filterOptions={(options, state) => {
              let newOptions = [];
              options.forEach((element) => {
                if (state.inputValue)
                  if (
                    element.label
                      .replace(', ', ' ')
                      .toLowerCase()
                      .includes(state.inputValue.replace(',', '').toLowerCase())
                  )
                    newOptions.push(element);
              });
              return newOptions;
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                error={Boolean(isError)}
                id={name}
                inputRef={field.ref}
                placeholder="Search by User ID or name"
              />
            )}
          />
        );
      }}
    />
  );
}
